var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['popit-item', { 'm-disable': !_vm.isActive }],on:{"click":_vm.onPopitClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }